import * as React from 'react';
import { Modal } from 'react-bootstrap';

interface IProps {
    show: boolean;
}

const SpinningDots = () => (
    <svg width="36" height="36" viewBox="0 0 32 32" fill="#337ab7" style={{ display: 'block' }}>
        <circle cx="16" cy="3" r="2.5"><animate attributeName="opacity" values="1;0.1;1" dur="1s" repeatCount="indefinite" begin="0s" /></circle>
        <circle transform="rotate(45 16 16)" cx="16" cy="3" r="2.5"><animate attributeName="opacity" values="1;0.1;1" dur="1s" repeatCount="indefinite" begin="0.125s" /></circle>
        <circle transform="rotate(90 16 16)" cx="16" cy="3" r="2.5"><animate attributeName="opacity" values="1;0.1;1" dur="1s" repeatCount="indefinite" begin="0.25s" /></circle>
        <circle transform="rotate(135 16 16)" cx="16" cy="3" r="2.5"><animate attributeName="opacity" values="1;0.1;1" dur="1s" repeatCount="indefinite" begin="0.375s" /></circle>
        <circle transform="rotate(180 16 16)" cx="16" cy="3" r="2.5"><animate attributeName="opacity" values="1;0.1;1" dur="1s" repeatCount="indefinite" begin="0.5s" /></circle>
        <circle transform="rotate(225 16 16)" cx="16" cy="3" r="2.5"><animate attributeName="opacity" values="1;0.1;1" dur="1s" repeatCount="indefinite" begin="0.625s" /></circle>
        <circle transform="rotate(270 16 16)" cx="16" cy="3" r="2.5"><animate attributeName="opacity" values="1;0.1;1" dur="1s" repeatCount="indefinite" begin="0.75s" /></circle>
        <circle transform="rotate(315 16 16)" cx="16" cy="3" r="2.5"><animate attributeName="opacity" values="1;0.1;1" dur="1s" repeatCount="indefinite" begin="0.875s" /></circle>
    </svg>
);

const DecisionSavingWarning: React.FC<IProps> = ({ show }) => (
    <Modal show={show} backdrop="static" dialogClassName="saving-warning-dialog" onHide={() => {}}>

        <style>{`.saving-warning-dialog { top: 50%; transform: translateY(-50%); margin-top: 0; }`}</style>
        <Modal.Body style={{ textAlign: 'center', padding: '30px 40px' }}>
            <div style={{ width: 60, height: 60, borderRadius: '50%', border: '1.5px solid #d0d0d0', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 18px' }}>
                <SpinningDots />
            </div>
            <p style={{ fontSize: '17px', fontWeight: 'bold', marginBottom: '10px' }}>Please do not refresh your page.</p>
            <p style={{ fontSize: '13px', color: '#555', marginBottom: '16px' }}>Your decision is being saved and may take a few moments to complete.</p>
            <p style={{ fontSize: '13px', color: '#5cb85c', marginBottom: 0 }}>
                <span className="glyphicon glyphicon-ok-circle" style={{ marginRight: 5 }} />
                Thank you for your patience.
            </p>
        </Modal.Body>
    </Modal>
);

export default DecisionSavingWarning;
